'use client';
import { useSearchParams } from 'next/navigation';
import { PropsWithChildren, useEffect, useRef } from 'react';

type Props = PropsWithChildren;

export default function CatalogsScrollArea({ children }: Props) {
  const listRef = useRef<HTMLDivElement | null>(null);

  const searchParams = useSearchParams();
  const skipText = searchParams.get('skipText');

  useEffect(() => {
    if (skipText && listRef.current) {
      setTimeout(() => {
        const topOffset = listRef.current!.offsetTop - 230;
        window.scrollTo({ top: topOffset, behavior: 'instant' });
      }, 100);
    }
  }, [listRef, skipText]);

  return (
    <div ref={listRef} className="pb-4 flex flex-wrap">
      <div className="block whitespace-nowrap overflow-x-scroll xl:overflow-x-hidden xl:whitespace-normal">
        {children}
      </div>
    </div>
  );
}
